import React from 'react';
import { Redirect } from 'react-router-dom';
import SessionStorageService from '../services/utilities/SessionStorageService';
import { getQueryStringParameter } from '../utilities/commonUtil';

export class RelayPoint extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      user: undefined,
    };

    this.authProvider = this.props.authProvider;
  }

  async componentDidMount() {
    const linkKey = getQueryStringParameter('__parameter');
    const sender = getQueryStringParameter('__sender');
    const loginId = getQueryStringParameter('loginId');
    const expectedLoginId = getQueryStringParameter('expectedLoginId');

    const relayPoint = {
      linkKey,
      sender,
      loginId,
    };

    if (expectedLoginId) {
      relayPoint.expectedLoginId = expectedLoginId;
    }

    SessionStorageService.setItem('relayPoint', JSON.stringify(relayPoint));

    const loggedInUser = await this.authProvider.getLoggedInUser();

    this.setState({ user: loggedInUser });
  }

  render() {
    //クライアントが認証状態でなかった場合、ログインページに移動し、ログイン後にランディングページにリダイレクトさせる。
    if (this.state.user === undefined) {
      return <div>ログイン情報の確認中です...</div>;
    }

    if (this.state.user === null) {
      this.authProvider.redirectLoginPage();
      return <div>ログイン情報の確認中です...</div>;
    }

    return <Redirect to='/callback' />;
  }
}



// WEBPACK FOOTER //
// ./src/components/RelayPoint.js